import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useHiddenAssets } from 'src/hooks/api'
import TableHidden from 'src/routes/Home/Assets/TableHidden/TableHidden'
import { checkAssets } from 'src/util/checkActives'

const HiddenList = () => {
  const hiddenAssets = useHiddenAssets()

  const assetsWithErrors = checkAssets(hiddenAssets)

  return (
    <>
      <h2>
        <strong>{hiddenAssets.length} </strong>
        <FormattedMessage id="hidden-assets.title" />
      </h2>
      <TableHidden assets={assetsWithErrors} />
    </>
  )
}

export default HiddenList
